export function capitalizeFirstLetter(string) {
  return string[0].toUpperCase() + string.slice(1);
}

export function getFrontendURL() {
  return process.env.REACT_APP_FRONTEND_URL;
}

export function getBackendURL() {
  return process.env.REACT_APP_BACKEND_API_URL + '/api/digicard';
}

export function getBackendBaseURL() {
  return process.env.REACT_APP_BACKEND_API_URL;
}

export function getBackendURLForResources() {
  return process.env.REACT_APP_BACKEND_API_URL + '/api/digicard/resources';
}

export function setAndClear(message, prop) {
  prop(message);
  setTimeout(() => prop(''), 1000);
}

export function getDate(dateString) {
  const date = new Date(dateString);
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
}

export function getSubRoutePath(user) {
  if (Object.keys(user).indexOf('level') === -1) {
    return undefined;
  }
  if (user.level === 0 || user.level === 2) {
    return 'admin';
  }
  if (user.level === 1) {
    return 'distributor';
  }
  return undefined;
}
